import { has } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  data: null,
  fetching: false,
  fetchError: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CASETYPES_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.CASETYPES_FETCHED:
      return {
        ...state,
        data: payload,
      };

    case types.CASETYPES_FETCH_ERROR:
      if (has(payload, 'response.data.Errors')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving Household Categorical Types. Please try again',
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/caseTypes/reducer.js